import Integration from "@app/types/integrations/Integration";
import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const integrationAnalytics = new AnalyticsService("Integrations");

export const getIntegrationAnalyticsSetupIssuer = (
  integrationType?: Integration["type"],
  step?: number
): AnalyticsService => integrationAnalytics.extend([`Setup ${integrationType}`, `Step ${step}`]);

export default integrationAnalytics;
